import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import '@growup/ui/styles.css';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root em falta no index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
